import {EgovProcedureRoutes} from './egovProcedures'
import {SettingRoutes} from './settings'
import {RouteParams} from 'types/routes'
import {DocumentRoutes} from './documents'
import {EmployeeRoutes} from './employees'
import {DirectRequestRoutes} from './directRequest'
import {ProcedureStatusRoutes} from './procedureStatuses'
import {AlertRoutes} from './alerts'
import {ChangeOfficeRoutes} from './changeOffice'
import {ChildcareLeaveRoutes} from './childcareLeave'
import {StartChildcareRoutes} from './startChildcare'
import {ExtendChildcareRoutes} from './extendChildcare'
import {FinishChildcareRoutes} from './finishChildcare'
import {AdditionalChildcareLeaveAllowanceRoutes} from './additionalChildcareLeaveAllowance'
import {ParentalLeaveRoutes} from './parentalLeave'
import {ParentalLeaveSupportAllowanceRoutes} from './parentalLeaveSupportAllowance'
import {HealthcareStartRoutes} from './healthcareStart'
import {SystemAnnouncesRoutes} from './systemAnnounces'
import {ProcedureNewRoutes} from './procedureNew'
import {HealthInsuranceQualificationConfirmationRoutes} from './healthInsuranceQualificationConfirmation'

export const withAuthAdminRoutes: RouteParams[] = [
  ...EmployeeRoutes,
  ...DirectRequestRoutes,
  ...DocumentRoutes,
  ...EgovProcedureRoutes,
  ...SettingRoutes,
  ...ProcedureStatusRoutes,
  ...AlertRoutes,
  ...ChangeOfficeRoutes,
  ...ChildcareLeaveRoutes,
  ...StartChildcareRoutes,
  ...ExtendChildcareRoutes,
  ...FinishChildcareRoutes,
  ...AdditionalChildcareLeaveAllowanceRoutes,
  ...ParentalLeaveRoutes,
  ...ParentalLeaveSupportAllowanceRoutes,
  ...HealthcareStartRoutes,
  ...SystemAnnouncesRoutes,
  ...ProcedureNewRoutes,
  ...HealthInsuranceQualificationConfirmationRoutes,
]
